import { POST_WITH_ID } from '@brickwise/asset-validation';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadPropertyDocuments } from 'src/components/ui/UploadDocument';

interface Props {
  disabled?: boolean;
}

export const UtilityReportUplaoder: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext<POST_WITH_ID>();

  return (
    <UploadPropertyDocuments
      disabled={disabled}
      showDivider={true}
      headline={t('dashboard.assets.addedit.main.uploadpropertydocuments.fields.utilityReport.label')}
      fileUrl={formik.values.documents?.utilityReport || ''}
      setFileUrl={(fileUrl) => formik.setFieldValue('documents.utilityReport', fileUrl)}
      tooltipContent={t('dashboard.assets.addedit.main.uploadpropertydocuments.tooltip')}
      nomenclatureField={'documents.utilityReport'}
    />
  );
};
